/**
 * components/index.js
 *
 * All components are listed here.  Whenever a new component is added. Add it here and import it from here.
 *
 * Example import usage:
 * import { Users } from 'components';
 */

// Global components
import EpicGamesToggle from './epicGamesToggle/EpicGamesToggle';
import PropertyLogo from './propertyLogo/PropertyLogo';
import SiteNav from './siteNav/SiteNav';
import SiteNavKids from './siteNav/SiteNavKids';

// Right nav components
import Search from './search/Search';
import SearchExtension from './search/SearchExtension';
//import SignInExtension from './signIn/SignInExtension';
import SignIn from './signIn/SignIn';
import SignedIn from './signedIn/SignedIn';
import UserIcon from './rightNav/UserIcon';
import Locale from './locale/Locale';
import LocaleIcon from './locale/LocaleIcon';
import CtaButton from './ctaButton/CtaButton';
import DividerLine from './dividerLine/DividerLine';
import MobileMenuButtons from './rightNav/MobileMenuButtons';

// Right nav layout
import RightNav from './rightNav/RightNav';

// EU cookie compliance message
import EuCookieMessage from './euCookieMessage/EuCookieMessage';

import Alert from './alert/Alert';

export {
    EpicGamesToggle,
    CtaButton,
    DividerLine,
    PropertyLogo,
    SiteNav,
    SiteNavKids,
    RightNav,
    Search,
    SearchExtension,
    SignedIn,
    UserIcon,
    SignIn,
    Locale,
    LocaleIcon,
    MobileMenuButtons,
    EuCookieMessage,
    Alert
};



// WEBPACK FOOTER //
// ./app/scripts/components/index.js